"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GiftOnHand = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var GiftOnHand = function GiftOnHand(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.81 7.073l-3.38 4.505c-.163.22-.403.367-.674.415l-5.832 1.029-.275.274.468.468L3.881 16 0 12.12l2.236-2.237.468.468 1.938-1.938c.343-.344.8-.532 1.285-.532h5.14a.563.563 0 01.048 1.122l-3.554.296.068.798L11.18 9.8a1.369 1.369 0 001.196-1.739l1.955-2.198a.95.95 0 01.686-.32c.26.013.516.092.704.279a.962.962 0 01.088 1.25zM6.355 1.366c.02-.11.14-.206.258-.206.316 0 .55.284.708.57h-.706c-.186-.114-.284-.244-.26-.364zM9.547.8c.153 0 .249.132.273.255.037.196-.088.459-.47.675h-.802c.18-.406.507-.93.999-.93zm-4.65 5.805h2.66V3.502h.886v3.103h2.66V3.502h.443V1.73h-1.08c.151-.287.186-.582.139-.826C10.502.372 10.066 0 9.546 0c-.822 0-1.329.635-1.62 1.19-.27-.422-.691-.83-1.314-.83-.501 0-.95.367-1.044.855a1.06 1.06 0 00.043.515H4.454v1.772h.443v3.103z",
    fill: "currentColor"
  }));
};

exports.GiftOnHand = GiftOnHand;
var _default = GiftOnHand;
exports.default = _default;